import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AlertTriangle, CheckCircle, Info, XCircle, X } from 'lucide-react';
import { cn } from '../../lib/utils';
const config = {
    success: {
        icon: CheckCircle,
        className: 'bg-green-50 text-green-800 border-green-200',
        iconClassName: 'text-green-500',
    },
    warning: {
        icon: AlertTriangle,
        className: 'bg-amber-50 text-amber-800 border-amber-200',
        iconClassName: 'text-amber-500',
    },
    error: {
        icon: XCircle,
        className: 'bg-red-50 text-red-800 border-red-200',
        iconClassName: 'text-red-500',
    },
    info: {
        icon: Info,
        className: 'bg-blue-50 text-blue-800 border-blue-200',
        iconClassName: 'text-blue-500',
    },
};
export function AlertBanner({ type, title, description, onDismiss, className }) {
    const { icon: Icon, className: alertClass, iconClassName } = config[type];
    return (_jsxs("div", { className: cn('flex items-start gap-3 rounded-lg border p-4', alertClass, className), role: "alert", children: [_jsx(Icon, { className: cn('h-5 w-5 flex-shrink-0 mt-0.5', iconClassName), "aria-hidden": true }), _jsxs("div", { className: "flex-1 min-w-0", children: [_jsx("p", { className: "font-medium text-sm", children: title }), description && _jsx("p", { className: "text-sm mt-0.5 opacity-80", children: description })] }), onDismiss && (_jsx("button", { onClick: onDismiss, className: "flex-shrink-0 rounded p-0.5 hover:bg-black/10 transition-colors", "aria-label": "Dismiss", children: _jsx(X, { className: "h-4 w-4" }) }))] }));
}
